/* Skullette FALL CLEARANCE claim-deal LP — form mount + season-ended swap. Contract with the HC build: this
 * page only inserts an empty <div id="sfd-claim-form"> for HC's embed script to hydrate, and only when the
 * visitor has no live access (else a "Shop my deal" link). Access read uses the SAME storage key/cookie +
 * 60-min rule as the live collection's skullette-fall-clearance-access.js (read-only, key sfc_access_v1).
 * Unlock itself stays the existing flow: Reply Y → FALL auto-reply SMS link (utm_source=sms); already-
 * subscribed → HC "open:" with utm_source=sms. Needs window.SFD (core module, loaded first).
 */
(function () {
  var A = window.SFD;
  if (!A) return;
  var root = A.root;
  var UNLOCK_URL = root.dataset.sfdUnlockUrl || '/collections/fall-clearance';
  var KEY = 'sfc_access_v1';
  var ACCESS_MS = (Number(root.dataset.sfdAccessMinutes) || 60) * 60000;

  function cookieGet(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function readAccessStart() {
    var raw = null;
    try { raw = localStorage.getItem(KEY); } catch (e) { /* ignore */ }
    if (!raw) raw = cookieGet(KEY);
    var start = Number(raw);
    return raw && !isNaN(start) ? start : null;
  }
  function hasLiveAccess() {
    var start = readAccessStart();
    return start != null && Date.now() < start + ACCESS_MS;
  }

  // ---- form card: mount vs "already open" vs ended ----
  var card = root.querySelector('[data-sfd-form-card]');
  var mountWrap = root.querySelector('[data-sfd-form-mount]');

  function paintOpen() {
    if (!mountWrap) return;
    mountWrap.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'sfd-form__open';
    wrap.innerHTML = '<a class="sfd-btn" href="' + A.esc(UNLOCK_URL) + '" data-hc-el="form-open-shop">Your deal is open — Shop my deal →</a>';
    mountWrap.appendChild(wrap);
  }
  function paintMount() {
    if (!mountWrap || document.getElementById('sfd-claim-form')) return;
    var mount = document.createElement('div');
    mount.id = 'sfd-claim-form';
    mountWrap.appendChild(mount);
  }
  function paintEnded() {
    var tpl = root.querySelector('[data-sfd-ended-template]');
    if (!card || !tpl) return;
    card.innerHTML = '';
    card.appendChild(tpl.content.cloneNode(true));
  }

  function paintFormCard() {
    if (A.isEnded()) { paintEnded(); return; }
    if (hasLiveAccess()) paintOpen(); else paintMount();
  }
  paintFormCard();
  root.addEventListener('sfd:ended', paintFormCard);
})();
